<!-- Copyright The Linux Foundation and each contributor to LFX. -->
<!-- SPDX-License-Identifier: MIT -->
<div class="mt-3">
    <h5 i18n>{{ tier?.name }}</h5>
    <div class="row no-gutters mb-2 justify-content-between border p-3 align-items-center" *ngFor="let subtier of tier?.subtiers; trackBy:membershipSubtierId"
         [class.border-primary]="subtier.id === selectedTierId">
        <div class="col-4">
            <span *ngIf="subtier.description && !subtier.minCompanySize" i18n>
                {{ subtier.description }}
            </span>
            <span *ngIf="subtier.minCompanySize && !subtier.maxCompanySize" i18n>
                {{ subtier.minCompanySize | number }}+ employees
            </span>
            <span *ngIf="!subtier.minCompanySize && subtier.maxCompanySize" i18n>
                &lt; {{ subtier.maxCompanySize | number }} employees
            </span>
            <span *ngIf="subtier.minCompanySize && subtier.maxCompanySize" i18n>
                {{ subtier.minCompanySize || "0" | number }} &ndash; {{ subtier.maxCompanySize | number }} employees
            </span>
        </div>
        <div class="col-4" i18n>
            ${{ subtier.price.amount || "0" | number }}
        </div>
        <div class="col-2" *ngIf="selectable" i18n>
            <button i18n class="btn btn-primary" (click)="select(tier, subtier)">
                Select
            </button>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// ./src/app/shared/membership-tier/membership-tier.component.html